import React from 'react';

import { Tooltip } from 'antd';

import styled from 'styled-components';

import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const BookTitleWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.5rem;

    .book-title-left {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 0.3rem;
        cursor: pointer;

        .badge {
            width: 0.5rem;
            height: 0.5rem;
            min-width: 0.5rem;
            min-height: 0.5rem;
            background: ${(props) => props.theme.DangerColor};
            border-radius: 100%;
        }
        .book-name {
            font-weight: ${(props) => (props.$isPublished ? '700' : '500')};
            font-size: ${(props) => (props.$compact ? '0.85rem' : '0.95rem')};
            max-height: 2.2em;
            line-height: 1.1em;
            overflow: hidden;
            text-overflow: ellipsis;
            /* white-space: nowrap; */
            color: ${(props) =>
                props.$sortableDragging
                    ? props.theme.TextColor
                    : props.$isFastPackage || props.$exist
                      ? props.theme.PrimaryColor
                      : props.theme.TextColor};
            text-transform: uppercase;
        }
        .book-icons {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-start;
            gap: 0.75rem;
            font-size: 1.1rem;
        }
    }
    .book-title-right {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        gap: 0.75rem;
        font-size: 1.1rem;
        padding-top: 0.25rem;
    }
`;

const BookItemTitle = ({
    book,
    compact,
    linkedSections,
    exist,
    sortableDragging,
    embeddedInSortableRow,
    sortableNoDragProps,
    onTitleClick,
    titleTooltip,
    actions,
}) => {
    const bookName = <div className="book-name">{book.Name}</div>;

    return (
        <BookTitleWrapper
            onClick={onTitleClick}
            $compact={compact}
            $isFastPackage={book.FastPackage}
            $exist={exist}
            $isPublished={linkedSections.length > 0}
            $sortableDragging={sortableDragging}
            style={embeddedInSortableRow ? { cursor: 'pointer' } : undefined}
            {...sortableNoDragProps}
        >
            <div className="book-title-left">
                {/* Solo sul nome: le icone qui sotto hanno già un tooltip proprio e
                    annidarli darebbe due tooltip sovrapposti sullo stesso hover. */}
                {titleTooltip ? <Tooltip title={titleTooltip}>{bookName}</Tooltip> : bookName}
                <div className="book-icons">
                    {linkedSections.length > 0 && (
                        <NwIcon
                            icon={byPrefixAndName.fasl['globe']}
                            tooltip={`published in ${linkedSections.length} division${linkedSections.length > 1 ? 's' : ''}`}
                        />
                    )}
                    {book.CompCard && <NwIcon icon={byPrefixAndName.fasl['image-polaroid-user']} tooltip="compcard" />}
                    {book.FastPackage && (
                        <NwIcon
                            icon={byPrefixAndName.fasl['truck-fast']}
                            tooltip="fast package book"
                            badgePosition="bottom-right"
                            badge={
                                book.FastPackageOrder !== null && book.FastPackageOrder !== ''
                                    ? book.FastPackageOrder + 1
                                    : null
                            }
                        />
                    )}
                    {book.IsFavourite && (
                        <NwIcon icon={byPrefixAndName.fasl['heart']} tooltip="one of my favourite books" />
                    )}
                </div>
            </div>
            {actions && (
                <div
                    className="book-title-right"
                    onClick={(e) => e.stopPropagation()}
                    onMouseDown={(e) => e.stopPropagation()}
                    onTouchStart={(e) => e.stopPropagation()}
                    onPointerDown={(e) => e.stopPropagation()}
                >
                    {actions}
                </div>
            )}
        </BookTitleWrapper>
    );
};

export default BookItemTitle;
